import React from "react";
import {Link} from "react-router-dom";
import Logo from "../icons/logo";

const Brand = () => {
    return (
        <Link to="/" className="brand">
            <div className="w-fit flex">
                <Logo className="logo" />
                <span className="name">Hoarfroster</span>
            </div>
        </Link>
    );
}

export default Brand;